'use client'

import { usePopup } from '@/contexts/PopupContext'
import React, { useEffect } from 'react'

const CheckCookie = () => {
    const { setPopup, setShowPopup } = usePopup()

    useEffect(() => {
        document.cookie = 'cookieconsent_status=allow; max-age=31536000; path=/'
        if (document.cookie.indexOf('cookieconsent_status=allow') === -1) {
            setPopup({
                status: 3,
                title: 'Cookie Consent',
                message: "Cookies are disabled. Please enable cookies to use this website."
            })

            setShowPopup(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return (
        <></>
    )
}

export default CheckCookie